var map = {
	"./anishl.webp": 5262,
	"./aniui.webp": 3927,
	"./aniuiacademy.png": 8101,
	"./aniuipro.png": 562,
	"./drezzo.webp": 8191,
	"./em.webp": 6419,
	"./portfolio.webp": 1751,
	"./portfolion.webp": 8211,
	"./portolio-v3.png": 9915,
	"./robofriends.webp": 510,
	"./smartbrain.webp": 7726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6247;